import { useState } from "react";
import { Navigate, useLocation, useNavigate, Link } from "react-router-dom";
import { ArrowUpRight, LockKeyhole } from "lucide-react";
import { useAuth } from "../auth/AuthContext";

const AdminLogin = () => {
  const { admin, login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (admin) {
    const to = loc.state?.from || "/admin";
    return <Navigate to={to} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
      nav(loc.state?.from || "/admin", { replace: true });
    } catch (e) {
      const d = e?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section style={{ minHeight: "calc(100vh - 84px)", display: "flex", alignItems: "center", padding: "80px 0" }}>
      <div className="container-grav">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6">
            <div className="eyebrow" style={{ marginBottom: 24 }}><span className="sep" />Admin access</div>
            <h1 className="display-lg">Restricted area.<br /><span className="text-green">Authorized personnel only.</span></h1>
            <p className="lede" style={{ marginTop: 24, maxWidth: 480, color: "var(--muted)" }}>
              This area houses consultation leads and operational dashboards. Credentials are issued to Gravitas partners only.
            </p>
            <Link to="/" className="arrow-link" style={{ marginTop: 40, display: "inline-flex" }}>Back to site</Link>
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            <form onSubmit={onSubmit} data-testid="admin-login-form" className="tile" style={{ padding: "48px 40px" }}>
              <div className="accent-bar" />
              <div style={{ width: 48, height: 48, borderRadius: "50%", background: "var(--green-bg)", color: "var(--green)", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                <LockKeyhole size={20} />
              </div>
              <h2 className="display-sm" style={{ marginTop: 24 }}>Sign in</h2>
              <div style={{ marginTop: 32, display: "flex", flexDirection: "column", gap: 24 }}>
                <div>
                  <label className="eyebrow">Email</label>
                  <input required type="email" className="input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="info@gravitastechnology.com" autoComplete="username" data-testid="admin-email" />
                </div>
                <div>
                  <label className="eyebrow">Password</label>
                  <input required type="password" className="input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" autoComplete="current-password" data-testid="admin-password" />
                </div>
              </div>
              {err && (
                <div data-testid="admin-login-error" style={{ marginTop: 24, color: "#B91C1C", fontSize: 14, border: "1px solid #FCA5A5", padding: "12px 16px", background: "#FEF2F2" }}>
                  {err}
                </div>
              )}
              <button type="submit" disabled={busy} className="btn" style={{ marginTop: 32, width: "100%", justifyContent: "center" }} data-testid="admin-login-submit">
                {busy ? "Signing in..." : "Sign in"}
                <span className="arrow"><ArrowUpRight size={14} strokeWidth={2.5} /></span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdminLogin;
